/* ==========================================================================
   MSS TEST PRODUCT — LOWER HALF

   One small custom element for the accordion grid. No library, no polling,
   no DOM observers. Everything else in the lower half is CSS only.

   Markup contract (see sections/mss-test-details.liquid):
     <mss-accordion data-single="true|false">
       <div class="mss-acc">
         <h3><button class="mss-acc__trigger" aria-expanded aria-controls="id"></button></h3>
         <div class="mss-acc__panel" id="id" role="region" aria-labelledby="...">
   ========================================================================== */

(function () {
  'use strict';

  if (typeof HTMLElement !== 'function' || !window.customElements) return;

  class MssAccordion extends HTMLElement {
    connectedCallback() {
      this.single = this.getAttribute('data-single') === 'true';

      this.items = Array.prototype.slice.call(
        this.querySelectorAll('.mss-acc')
      );

      this.triggers = this.items
        .map((item) => item.querySelector('.mss-acc__trigger'))
        .filter(Boolean);

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.toggle(trigger));
        trigger.addEventListener('keydown', (event) => this.onKeydown(event, trigger));
      });
    }

    itemFor(trigger) {
      return trigger.closest('.mss-acc');
    }

    isOpen(trigger) {
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    setState(trigger, open) {
      var item = this.itemFor(trigger);
      if (!item) return;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.classList.toggle('is-open', open);

      var panel = item.querySelector('.mss-acc__panel');
      if (panel) panel.hidden = false; // height is handled in CSS, not hidden
    }

    toggle(trigger) {
      var open = !this.isOpen(trigger);

      if (open && this.single) {
        this.triggers.forEach((other) => {
          if (other !== trigger) this.setState(other, false);
        });
      }

      this.setState(trigger, open);
    }

    onKeydown(event, trigger) {
      var key = event.key;
      if (
        key !== 'ArrowDown' &&
        key !== 'ArrowUp' &&
        key !== 'Home' &&
        key !== 'End'
      ) {
        return;
      }

      event.preventDefault();
      var index = this.triggers.indexOf(trigger);
      var next = index;

      if (key === 'ArrowDown') next = (index + 1) % this.triggers.length;
      if (key === 'ArrowUp') next = (index - 1 + this.triggers.length) % this.triggers.length;
      if (key === 'Home') next = 0;
      if (key === 'End') next = this.triggers.length - 1;

      this.triggers[next].focus();
    }
  }

  if (!customElements.get('mss-accordion')) {
    customElements.define('mss-accordion', MssAccordion);
  }
})();
